import React from 'react';
import _ from 'lodash';
import * as styles from './index.module.scss';

const CashbackTracker = ({
  T,
  appStyles,
  cashbackDiscounts,
  currencySymbol,
  appCurrencySymbol,
  hasClearBackground=false
}) => {
  return (
    <>
      {!_.isEmpty(cashbackDiscounts) &&
        _.map(cashbackDiscounts, (cashbackDiscount) => {
          return (
            <div
              style={{ margin: "0 10px 0 10px" , ...appStyles.CashbackTrackerDiv || {}}}
              key={cashbackDiscount.policyId}
              className={hasClearBackground ? styles.ClearBackground : ""}
            >
              <span
                style={{
                  color: hasClearBackground ? appStyles.titleColor : appStyles.titleOnBackgroundColor,
                }}
              >
                {T(
                  `We give you ${appCurrencySymbol}${
                    cashbackDiscount.cashbackAmount
                  } for every ${currencySymbol}${
                    cashbackDiscount.amountToSpendForCashback
                  } you spend`,
                )}
              </span>

              <div className={styles.RemainderBar}>
                <div
                  className={styles.FillBar}
                  style={{
                    background: appStyles.accentColor,
                    width: `${cashbackDiscount.percentFilled}%`,
                  }}
                />
                {cashbackDiscount.percentFilled > 10 && (
                  <div className={styles.MoneyIndicatorWrapper}>
                    <div className={styles.MoneyIndicator}>{"|"}</div>
                    <div
                      className={styles.MoneyIndicator}
                    >{`${currencySymbol}0`}</div>
                  </div>
                )}

                <div
                  className={styles.MoneyIndicatorWrapper}
                  style={{
                    width: `${cashbackDiscount.percentFilled * 2}%`,
                    alignItems: "center",
                  }}
                >
                  <div className={styles.MoneyIndicator}>{"|"}</div>
                  <div
                    className={styles.MoneyIndicator}
                  >{`${currencySymbol}${cashbackDiscount.amountSpent.toFixed(
                    appStyles.pointsRewards ? 0 : 2,
                  )}`}</div>
                </div>

                {cashbackDiscount.percentFilled < 84 && (
                  <div
                    className={styles.MoneyIndicatorWrapper}
                    style={{
                      ...(appStyles.rtl ? { left: 0 } : { right: 0 }),
                      alignItems: "flex-end",
                    }}
                  >
                    <div className={styles.MoneyIndicator}>{"|"}</div>
                    <div
                      className={styles.MoneyIndicator}
                    >{`${currencySymbol}${
                      cashbackDiscount.amountToSpendForCashback
                    }`}</div>
                  </div>
                )}
              </div>
            </div>
          );
        })}
    </>
  );
};

export default CashbackTracker; 